import React from "react";
import { ShoppingBag, Award } from "lucide-react";

/**
 * Visual indicator of which CXOORA channel a request/proposal/project belongs to.
 *  - marketplace: blue, ShoppingBag
 *  - agency: gold, Award
 */
export const ChannelBadge = ({ channel, size = "sm", showLabel = true }) => {
  const isAgency = channel === "agency";
  const cls = size === "lg"
    ? "px-2.5 py-1 text-xs"
    : size === "xs"
      ? "px-1.5 py-0 text-[10px]"
      : "px-2 py-0.5 text-[11px]";

  if (isAgency) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full font-semibold ${cls} bg-gradient-to-r from-[#F2D27A] to-[#B7791F] text-white border border-[#B7791F]/40 shadow-sm`}
        data-testid="channel-badge-agency"
      >
        <Award size={size === "xs" ? 10 : 12} />
        {showLabel && "Agency Premium"}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${cls} bg-[#EAF0FF] text-[#2D6BFF] border border-[#2D6BFF]/20`}
      data-testid="channel-badge-marketplace"
    >
      <ShoppingBag size={size === "xs" ? 10 : 12} />
      {showLabel && "Marketplace"}
    </span>
  );
};

/**
 * Inline tooltip-like explainer
 */
export const ChannelExplainer = ({ channel }) => {
  if (channel === "agency") {
    return (
      <p className="text-xs text-[#8B5E12] mt-1">
        CXOORA opera come fornitore principale con SLA e account manager dedicato.
      </p>
    );
  }
  return (
    <p className="text-xs text-[#2D6BFF] mt-1">
      Matching algoritmico — la collaborazione è diretta tra azienda e manager.
    </p>
  );
};

/**
 * Mini-card switcher between channels (used in checkup step 9)
 */
export const ChannelToggleCard = ({ value, onChange, suggested }) => {
  const opts = [
    {
      value: "marketplace",
      title: "Marketplace",
      desc: "Self-service. Vedi manager, contatti direttamente, fee 15%.",
      icon: ShoppingBag,
      color: "#2D6BFF",
      bg: "#EAF0FF",
    },
    {
      value: "agency",
      title: "Agency Premium",
      desc: "Account manager dedicato, SLA, riservatezza tri-party.",
      icon: Award,
      color: "#B7791F",
      bg: "#FFF6E6",
    },
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {opts.map((o) => {
        const active = value === o.value;
        const isSuggested = suggested === o.value;
        return (
          <button
            type="button"
            key={o.value}
            onClick={() => onChange(o.value)}
            data-testid={`channel-card-${o.value}`}
            className={`text-left p-4 rounded-xl border-2 transition ${
              active
                ? "border-[#2D6BFF] bg-[#EAF0FF]/40 shadow-md"
                : "border-slate-200 bg-white hover:border-slate-300"
            }`}
          >
            <div className="flex items-center gap-2 mb-2">
              <span className="rounded-lg p-1.5" style={{ background: o.bg, color: o.color }}>
                <o.icon size={16} />
              </span>
              <h4 className="font-display font-semibold text-slate-900">{o.title}</h4>
              {isSuggested && (
                <span className="ml-auto text-[10px] px-1.5 py-0.5 rounded-full bg-[#1F9D6A] text-white font-semibold">
                  Consigliato
                </span>
              )}
            </div>
            <p className="text-xs text-slate-600">{o.desc}</p>
          </button>
        );
      })}
    </div>
  );
};
